import { linkPropsSchema } from '../component-catalog.js';
export const linkDefinition = {
    type: 'Link',
    category: 'content',
    propsSchema: linkPropsSchema,
    isDataBacked: false,
    needsMeasuredDims: false,
    description: 'Hyperlink to an external URL. Props: text (required), href (required, https only), external?.',
};
//# sourceMappingURL=Link.js.map